export default "<formly-form model=\"searchModel.filteredBy\" fields=\"ctrl.form.fields\" form=\"kzSearchForm\" aria-label=\"Filed\"></formly-form>\n";